let config = {}

if (process.env.VUE_APP_BUILD_ENV === 'prod') {
  config = require('./prod').default
}
if (process.env.VUE_APP_BUILD_ENV === 'stg') {
  config = require('./stg').default
}
if (process.env.VUE_APP_BUILD_ENV === 'dev') {
  config = require('./dev').default
}
if (process.env.VUE_APP_BUILD_ENV === 'local') {
  config = require('./local').default
}
if (process.env.VUE_APP_BUILD_ENV === 'kmh') {
  config = require('./kmh').default
}

export default config
